/* Product-page helpers: ATC price sync, delivery countdown, share-copy.
 * Vanilla JS on purpose (runs anywhere the buy-buttons snippet renders). */
(() => {
  /* This file is rendered from inside the product form, so a section re-render
   * re-executes it. Bail out on the second run so the subscribers and the
   * countdown timer are not stacked. */
  if (window.__kpProductPageReady) return;
  window.__kpProductPageReady = true;

  /* --- Keep the priced submit label after Dawn refreshes a variant. --- */
  if (typeof subscribe === 'function') {
    subscribe('variant-change', (event) => {
      const data = event && event.data;
      if (!data || !data.variant || !data.sectionId || !data.html) return;
      const id = `ProductSubmitButton-${data.sectionId}`;
      const sourceLabel = data.html.getElementById(id)?.querySelector(':scope > span');
      const currentLabel = document.getElementById(id)?.querySelector(':scope > span');
      if (sourceLabel && currentLabel) currentLabel.textContent = sourceLabel.textContent;
    });
  }

  /* --- Delivery estimate: one shared tick for every line on the page. --- */
  const lines = new Set();
  let timer;
  const days = (el, date) => {
    const locale = el.dataset.locale || undefined;
    return date.toLocaleDateString(locale, { weekday: 'long', day: 'numeric', month: 'long' });
  };
  const addDate = (from, offset) => {
    const date = new Date(from);
    date.setDate(date.getDate() + offset);
    return date;
  };
  const paintDates = (el) => {
    const now = new Date();
    const minEl = el.querySelector('[data-kp-delivery-min]');
    const maxEl = el.querySelector('[data-kp-delivery-max]');
    if (minEl) minEl.textContent = days(el, addDate(now, parseInt(el.dataset.minDays || '5', 10)));
    if (maxEl) maxEl.textContent = days(el, addDate(now, parseInt(el.dataset.maxDays || '9', 10)));
  };
  const tick = () => {
    const now = new Date();
    const end = new Date();
    end.setHours(23, 59, 59, 999);
    const left = Math.max(0, Math.floor((end - now) / 1000));
    const h = String(Math.floor(left / 3600)).padStart(2, '0');
    const m = String(Math.floor((left % 3600) / 60)).padStart(2, '0');
    lines.forEach((el) => {
      const cd = el.querySelector('[data-kp-delivery-countdown]');
      if (cd) cd.textContent = (el.dataset.countdownFormat || '[h] hours [m] mins')
        .replace('[h]', h)
        .replace('[m]', m);
    });
    if (!lines.size) {
      clearInterval(timer);
      timer = undefined;
    }
  };
  const register = (scope = document) => {
    scope.querySelectorAll('[data-kp-delivery]').forEach((el) => {
      if (el.dataset.kpDeliveryReady) return;
      el.dataset.kpDeliveryReady = '1';
      paintDates(el);
      lines.add(el);
    });
    if (lines.size && !timer) {
      tick();
      timer = setInterval(tick, 30000);
    }
  };
  const drop = (scope) => {
    scope.querySelectorAll('[data-kp-delivery]').forEach((el) => {
      lines.delete(el);
      delete el.dataset.kpDeliveryReady;
    });
  };
  register();
  document.addEventListener('shopify:section:load', (event) => register(event.target));
  document.addEventListener('shopify:section:unload', (event) => drop(event.target));

  /* --- Share row: native share sheet, else copy link. --- */
  document.querySelectorAll('[data-kp-share-copy]').forEach((btn) => {
    if (btn.dataset.kpShareReady) return;
    btn.dataset.kpShareReady = '1';
    btn.addEventListener('click', async () => {
      const wrap = btn.closest('.kp-product-links');
      const status = wrap ? wrap.querySelector('[data-kp-share-status]') : null;
      const say = (msg) => { if (status) status.textContent = msg; };
      const url = window.location.href;
      if (navigator.share) {
        try {
          await navigator.share({ url, title: document.title });
          say(btn.dataset.copiedLabel || 'Link copied');
          return;
        } catch (_) {
          // Dismissed or unsupported in this context - fall through to the
          // clipboard so the shopper still gets the link.
        }
      }
      if (navigator.clipboard && navigator.clipboard.writeText) {
        try {
          await navigator.clipboard.writeText(url);
          say(btn.dataset.copiedLabel || 'Link copied');
        } catch (_) { say('Copy the link manually'); }
      } else {
        say('Copy the link manually');
      }
    });
  });
})();
